import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export function Login() {
  const navigate = useNavigate();
  const [botUsername, setBotUsername] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .whoami()
      .then((r) => {
        if (r.user) {
          navigate("/", { replace: true });
        } else {
          setBotUsername(r.botUsername || "");
        }
      })
      .catch(() => setError("Could not reach the server."));
  }, [navigate]);

  const deepLink = botUsername
    ? `https://t.me/${botUsername}?start=login`
    : null;

  return (
    <div className="page page-pad-bottom">
      <h1>Sign in</h1>
      <p className="big muted">
        We sign you in through Telegram so there's no password to remember.
      </p>
      {error && <div className="card" style={{ color: "var(--warn)" }}>{error}</div>}
      <div className="card">
        <p className="big">
          1. Tap the button below to open our family bot in Telegram.
        </p>
        <p className="big">
          2. Tap <b>Start</b> in Telegram.
        </p>
        <p className="big">
          3. The bot will send you a sign-in link. Tap it to come back here.
        </p>
        {deepLink ? (
          <a className="btn" href={deepLink} style={{ width: "100%", marginTop: "0.5rem" }}>
            Open Telegram to sign in
          </a>
        ) : (
          <p className="muted">Bot username not configured. Ask the admin to fix the .env.</p>
        )}
      </div>
      <p className="muted center">
        New here? You need an invite link from a family admin.
      </p>
    </div>
  );
}
